<i18n src="@/i18n/backoffice/dashboard/page.json"></i18n>
<template>
	<Card :title="$t('dashboard.last_12_months')">
		<div class="p-4">
			<canvas ref="chart"></canvas>
		</div>
	</Card>
</template>
<script>

import Card from "@/components/Card.vue"
import Chart from "chart.js/auto"
// import { Chart } from "chart.js"
import Dashboard from "@/API/Dashboard.js"

export default {
	name: "LastTwelveMonthsChart",
	components: {
		Card
	},
	data() {
		return {
			chartData: {
				// "labels": [
				// 	"May\/2024",
				// 	"Jun\/2024",
				// 	"Jul\/2024",
				// 	"Aug\/2024",
				// 	"Sep\/2024",
				// 	"Oct\/2024",
				// 	"Nov\/2024",
				// 	"Dec\/2024",
				// 	"Jan\/2025",
				// 	"Feb\/2025",
				// 	"Mar\/2025",
				// 	"Apr\/2025",
				// 	"May\/2025"
				// ],
				// "datasets": [
				// 	{
				// 		"label": "Confirmadas",
				// 		"data": [
				// 			2028,
				// 			2283,
				// 			2278,
				// 			2353,
				// 			2332,
				// 			2583,
				// 			2085,
				// 			1806,
				// 			2174,
				// 			2352,
				// 			2142,
				// 			2440,
				// 			1089
				// 		],
				// 		borderColor: 'rgba(27, 203, 203,1)',
				// 		fill: false,
				// 		tension: 0.4,
				// 		pointRadius : 4,
				// 		pointStrokeWidth : 2,
				// 		datasetStrokeWidth : 3,
				// 		scaleShowVerticalLines: false,
				// 		scaleGridLineWidth : 2,
				// 		scaleShowGridLines : false,
				// 		scaleGridLineColor : "rgba(225, 255, 255, 1)",
				// 		scaleOverride: true,
				// 		scaleSteps: 9,
				// 		scaleStepWidth: 500,
				// 		scaleStartValue: 0,
				// 	}
				// ]
			}
		}
	},
	methods: {
		async renderChart() {
			const [err, res] = await Dashboard.loadChart("shipments:last-twelve-months")

			const ctx = this.$refs.chart.getContext('2d')

			const gradient = ctx.createLinearGradient(0, 0, 0, 400)
			gradient.addColorStop(0, 'rgba(27, 203, 203,1)')
			gradient.addColorStop(1, 'rgba(255, 255, 255,0.1)')

			this.chartData.labels = res.data.data.labels
			this.chartData.datasets = [ res.data.data.datasets[1] ]

			Object.assign(this.chartData.datasets[0].data, {
				backgroundColor: gradient,
				fill: true,
				tension: 0.4,
				pointRadius : 4,
				pointStrokeWidth : 2,
				datasetStrokeWidth : 3,
				scaleShowVerticalLines: false,
				scaleGridLineWidth : 2,
				scaleShowGridLines : false,
				scaleGridLineColor : "rgba(225, 255, 255, 1)",
				scaleOverride: true,
				scaleSteps: 9,
				scaleStepWidth: 500,
				scaleStartValue: 0,
			})

			this.chart = new Chart(this.$refs.chart, {
				type: "line",
				data: this.chartData,//res.data.data,
				tension: 0.4,
				options: {
					plugins: {
						legend: {
							display: false,
						},
					},
					scales: {
						visible: false,
						y: {
							visible: true,
							min: 600,
							beginAtZero: true,
							grid: {
								display: true,
								color: () => '#EBEBEB'
							}
						},
						x: {
							grid: {
								display: true,
								color: () => '#EBEBEB'
							}
						}
					}
				}
			})
		}
	},
	mounted() {
		this.renderChart()
	}
}

</script>
